import React from "react";
import { connect } from "react-redux";
import SuccessorInfo from "./SuccessorInfo";
import AddressInfo from "./AddressInfo";
import { resetZipCode, resetAllZipFields } from "../../../../../CommonComponents/Zipcode/actions";
class Form extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {
      formData: this.props.data,
      isAddressFormValid: true,
      isSuccessorFormValid:true,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      formData: nextProps.data
    });
  }

  updateSuccessorInfo = ({data, isFormValid}) => {
    this.setState((prevState) => {
      return {
        formData: {...prevState.formData, ...data},
        isSuccessorFormValid:isFormValid
      };
    }, () => {
      this.props.handleFormChange({formData: this.state.formData ,
        isFormValid : this.state.isAddressFormValid && this.state.isSuccessorFormValid}, this.props.successorKey)
    });
  }
  updateAddressInfo = ({data, isFormValid}) => {
    this.setState((prevState) => {
        return {
            formData: {...prevState.formData, ...data},
            isAddressFormValid: isFormValid,
        }
    }, () => {
        this.props.handleFormChange({formData: this.state.formData ,
           isFormValid : this.state.isAddressFormValid && this.state.isSuccessorFormValid}, this.props.successorKey)
    });
}

  render() {
    const legacyValues = this.state.formData;
    const {validateForm} = this.props;
    return (
      <div>
        <SuccessorInfo
          selectedPlans={this.props.selectedPlans}
          optionId={this.props.optionId}
          successorData={legacyValues}
          handleFormChange={this.updateSuccessorInfo}
          successorKey={this.props.successorKey}
          contentKey={this.props.contentKey}
          relationshipDropDown={this.props.relationshipDropDown}
          suffixDropDown={this.props.suffixDropDown}
          titleDropDown={this.props.titleDropDown}
          validateForm={validateForm}
          legacyFormValid= {this.props.legacyFormValid}          
        />

        <AddressInfo
          selectedPlans={this.props.selectedPlans}
          addressData={legacyValues.address}
          handleFormChange={this.updateAddressInfo}
          stateDropDown={this.props.stateDropDown}
          countryDropDown={this.props.countryDropDown}
          successorKey={this.props.successorKey}
          contentKey={this.props.contentKey}
          validateForm={validateForm}
          legacyFormValid= {this.props.legacyFormValid}
          zipCodeData={this.props.zipCodeData.toJS()}
          resetZipCode={(val, field)=>this.props.resetZipCode(val, field)}
          resetAllZipCode={(val) => this.props.resetAllZipCode(val)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  countryDropDown: state.getIn([
    "myAccount",
    "dropdownValues",
    "data",
    "countries"
  ]),
  stateDropDown: state.getIn(["myAccount", "dropdownValues", "data", "states"]),
  relationshipDropDownLoader: state.getIn([
    "myAccount",
    "relationshipValues",
    "isLoading"
  ]),
  titleDropDown: state.getIn(["myAccount", "dropdownValues", "data", "title"]),
  suffixDropDown: state.getIn([
    "myAccount",
    "dropdownValues",
    "data",
    "suffix"
  ]),
  relationshipDropDown: state.getIn([
    "myAccount",
    "relationshipValues",
    "data"
  ]),
  zipCodeData: state.getIn(['zipCode', 'zipCodes'])
});

const mapDispatchToProps = dispatch => ({
  resetZipCode: (val, field) => dispatch(resetZipCode(val, field)),
  resetAllZipCode: (val) => dispatch(resetAllZipFields(val)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form);
